import React, { useState, useEffect } from 'react';
import {
  Form,
  Input,
  Grid,
  DatePicker,
  InputNumber,
  Select,
  Checkbox,
} from '@arco-design/web-react';
import { fetchCountryCodesFromAPI } from '../../common/functions/GetCountryCode/GetCountryCode';
const { RangePicker } = DatePicker;
const TextArea = Input.TextArea;
const InputField = ({
  type = 'text',
  field,
  label,
  span,
  required = false,
  rules = [],
  value,
  maxLength,
  labelInValue,
  options = [], // For select options
  max,
  showSearch,
  onChange = () => {}, // Fallback function
  placeholder,
  format = 'DD-MM-YYYY',
  disabledDate,
  showTime = false,
  inputStyle,
  allowClear,
  defaultVisibility = false, // For password inputs
  checkboxLabel, // Label for checkbox
  countryCode = '+91', // Default country code
  onCountryChange = () => {}, // Callback for country code change
}) => {
  const [selectedCountryCode, setSelectedCountryCode] = useState(countryCode);
  const [countryCodes, setCountryCodes] = useState([]); // Start with empty array
  const [isLoadingCountryCodes, setIsLoadingCountryCodes] = useState(false);

  useEffect(() => {
    const loadCountryCodes = async () => {
      if (type === 'number') {
        setIsLoadingCountryCodes(true);
        try {
          const apiCountryCodes = await fetchCountryCodesFromAPI();
          if (apiCountryCodes && apiCountryCodes.length > 0) {
            setCountryCodes(apiCountryCodes);
          }
        } catch (error) {
          console.error('Failed to load country codes from API:', error);
        } finally {
          setIsLoadingCountryCodes(false);
        }
      }
    };

    loadCountryCodes();
  }, [type]);

  const handleCountryCodeChange = (code) => {
    setSelectedCountryCode(code);
    onCountryChange(code);
  };
  const renderInput = () => {
    switch (type) {
      case 'text':
        return (
          <Input
            style={inputStyle}
            placeholder={placeholder}
            maxLength={maxLength}
            value={value}
            onChange={onChange} // Call parent-provided onChange
          />
        );
      case 'password':
        return (
          <Input.Password
            style={inputStyle}
            placeholder={placeholder}
            visibilityToggle
            maxLength={maxLength}
            value={value}
            onChange={onChange}
            defaultVisibility={defaultVisibility}
          />
        );
      case 'number':
        return (
          <Input
            style={inputStyle}
            placeholder={placeholder}
            maxLength={maxLength}
            value={value}
            onChange={onChange}
            addBefore={
              <Select
                placeholder="Code"
                style={{ width: 95, marginRight: 3 }}
                value={selectedCountryCode}
                onChange={handleCountryCodeChange}
                showSearch
                triggerProps={{ updateOnScroll: true, autoFixPosition: true }}
                labelInValue={labelInValue}
                loading={isLoadingCountryCodes}
                filterOption={(inputValue, option) =>
                  option.props.value
                    .toLowerCase()
                    .indexOf(inputValue.toLowerCase()) >= 0 ||
                  option.props.children
                    .toLowerCase()
                    .indexOf(inputValue.toLowerCase()) >= 0
                }
              >
                {countryCodes.map((country) => (
                  <Select.Option key={country.label} value={country.value}>
                    {country.label}
                  </Select.Option>
                ))}
              </Select>
            }
            allowClear={allowClear}
          />
        );
      case 'date-range':
        return (
          <RangePicker
            style={inputStyle}
            placeholder={placeholder || ['Start Date', 'End Date']}
            format={format}
            disabledDate={(current) => current && current > new Date()}
            showTime={showTime}
            allowClear
          />
        );
      case 'date':
        return (
          <DatePicker
            style={inputStyle}
            placeholder={placeholder || 'Select Date'}
            value={value}
            onChange={onChange}
            format={format}
            disabledDate={disabledDate}
            showTime={showTime}
            allowClear
          />
        );
      case 'select':
        return (
          <Select
            labelInValue={labelInValue}
            style={inputStyle}
            placeholder={placeholder}
            value={value}
            triggerProps={{ updateOnScroll: true, autoFixPosition: true }}
            showSearch={showSearch}
            onChange={onChange}
            allowClear={allowClear} // Enable clear button for Select
          >
            {options.map((option) => (
              <Select.Option key={option.value} value={option.label}>
                {option.label}
              </Select.Option>
            ))}
          </Select>
        );
      case 'checkbox':
        return (
          <Checkbox checked={value} onChange={onChange}>
            {checkboxLabel}
          </Checkbox>
        );
      case 'textarea':
        return (
          <TextArea
            style={{
              ...inputStyle,
              minHeight: '100px',
              maxHeight: '200px',
              overflowY: 'auto',
            }}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            maxLength={maxLength}
            allowClear={allowClear}
          />
        );

      default:
        return null;
    }
  };

  return (
    <Grid.Col span={span} xs={24} sm={24} md={span}>
      <Form.Item
        label={label}
        field={field}
        rules={rules}
        required={required}
        style={{ width: '100%' }}
        layout="vertical" // Ensure label is displayed above input
      >
        {renderInput()}
      </Form.Item>
    </Grid.Col>
  );
};

export default InputField;
